import { gql } from "@apollo/client";
import Stack from "atoms/Stack";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK_LIGHTER, COLOR_WHITE_LIGHTER } from "helpers/colors";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import useEnforceAuth from "helpers/useEnforceAuth";
import Message from "molecules/Message";
import Splash from "molecules/Splash";
import EditAccountForm, { EditAccountFormFragment } from "pages/account/EditAccountForm";
import React from "react";

export default function AccountPage() {
  useEnforceAuth({ enforceAuthenticated: true });

  const [data] = useData(gql`
    query AccountPageCurrentUser {
      currentUser {
        id
        email
        onboarded
        ...EditAccountFormFragment
      }
    }
    ${EditAccountFormFragment}
  `);

  return (
    <>
      <Splash
        title="Account Settings"
        descriptionHeader="Edit your account details"
        descriptionValue={data?.currentUser?.email}
        color={COLOR_BLACK_LIGHTER}
      />
      <Stack
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          gap: SPACING,
          paddingTop: SPACING,
          width: `calc(100vw - ${SPACING} * 2)`,
          maxWidth: MAX_CONTENT_WIDTH,
          margin: "0 auto",
        }}
      >
        {data?.currentUser && !data.currentUser.onboarded && (
          <Message>
            Set your password now and log in anytime at{" "}
            <a
              style={{ color: COLOR_WHITE_LIGHTER, fontWeight: 500 }}
              target="_blank"
              href="https://my.gloryleague.basketball/login"
              rel="noreferrer"
            >
              my.gloryleague.basketball
            </a>{" "}
            to access your Glory League.
          </Message>
        )}
        {data?.currentUser && <EditAccountForm user={data.currentUser} />}
      </Stack>
    </>
  );
}
